<template>
  <div class="controlRange">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容-->
    <div class="department-content">
      <el-row type="flex" :gutter="10">
        <el-col :span="6">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('company.title') }}</span>
              <span
                class="i-icon"
                v-bind:style="{
                  display: userInfo.userInfo.adminFlag == 1 ? 'inline-block' : 'none',
                }"
              >
                <template v-for="(item, i) in menuButtonList">
                  <svg-icon
                    class="icon-img"
                    style="font-size: 16px; padding-left: 10px"
                    :key="i"
                    v-if="item.type == '0'"
                    :class="item.attributes.buttonStyle"
                    :title="item.label"
                    @click="chooseClick(item.attributes.buttonUrl, item)"
                    :icon-class="item.attributes.buttonStyle"
                  />
                  <!--<i-->
                  <!--  :key="i"-->
                  <!--  v-if="item.type == '0'"-->
                  <!--  :class="item.attributes.buttonStyle"-->
                  <!--  :title="item.label"-->
                  <!--  @click="chooseClick(item.attributes.buttonUrl,item)"-->
                  <!--&gt;</i>-->
                </template>
              </span>
            </div>
            <el-tree
              :data="data"
              :props="defaultProps"
              :default-expand-all="false"
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              ref="tree"
              v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  :style="{ color: data.attributes.currentStatus == '1' ? '#ccc' : '#606266' }"
                  >{{ node.label }}</span
                >
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="18" style="background-color: #ffffff">
          <!--管理员-->
          <div v-if="userInfo.userInfo.adminFlag == 1">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <el-tab-pane :label="firstLabel" name="first">
                <!--控制范围和部门详情-->
                <div class="detail" v-if="!edit">
                  <departmentDetail
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    :unitData="unitData"
                    ref="departmentDetail"
                  ></departmentDetail>
                  <controlRangeDetail
                    v-else
                    :receiptClaimModeList="receiptClaimModeList"
                    :detail="detail"
                    :tableData="tableData"
                    ref="controlRangeDetail"
                  ></controlRangeDetail>
                </div>
                <!--控制范围和部门修改-->
                <div class="detail" v-else>
                  <editDepartment
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    :unitData="unitData"
                    @getData="getData"
                    @setLoading="setLoading"
                    ref="editDepartment"
                  ></editDepartment>
                  <editControlRange
                    v-else
                    :detail="detail"
                    :receiptClaimModeList="receiptClaimModeList"
                    :tableData="tableData"
                    @getData="getData"
                    @setLoading="setLoading"
                    ref="editControlRange"
                  ></editControlRange>
                </div>
                <!--底部操作按钮-->
                <div class="footer" v-if="edit">
                  <el-button :loading="load" @click="updateSure()" type="primary">{{
                    $t('dialog.confirm')
                  }}</el-button>
                  <el-button @click="edit = false">{{ $t('dialog.cancel') }}</el-button>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('company.system')" name="second">系统映射表</el-tab-pane>
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!--普通账号-->
          <div v-if="userInfo.userInfo.adminFlag == 2">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <el-tab-pane :label="firstLabel" name="first">
                <div class="detail">
                  <departmentDetail
                    :receiptClaimModeList="receiptClaimModeList"
                    v-if="detail.type == 'department'"
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    ref="departmentDetail"
                  ></departmentDetail>
                  <controlRangeDetail
                    v-else
                    :receiptClaimModeList="receiptClaimModeList"
                    :detail="detail"
                    :tableData="tableData"
                    ref="controlRangeDetail"
                  ></controlRangeDetail>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <addControl
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      ref="addControl"
    ></addControl>
    <addDepartment
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      :tableData="tableData"
      ref="addDepartment"
    ></addDepartment>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import departmentDetail from '../components/detail/departmentDetail';
  import controlRangeDetail from '../components/detail/controlRangeDetail';
  import addControl from '../components/addModal/addControl';
  import addDepartment from '../components/addModal/addDepartment';
  import editControlRange from '../components/edit/editControlRange';
  import editDepartment from '../components/edit/editDepartment';
  import historyData from '../components/detail/historyData';

  export default {
    name: 'controlRange',
    components: {
      SiruiSearch,
      departmentDetail,
      controlRangeDetail,
      addControl,
      addDepartment,
      editControlRange,
      editDepartment,
      historyData,
    },
    data() {
      return {
        activeName: 'first',
        query: {
          controlAreaName: null,
          currentStatus: null,
        },
        data: [],
        defaultProps: {
          children: 'children',
          label: function (data) {
            return data.pid || data.label;
          },
        },
        detail: {},
        menuButtonList: [],
        tableData: [],
        unitData: [],
        edit: false,
        load: false,
        historyData: [],
      };
    },
    computed: {
      firstLabel: {
        get: function () {
          if ('department' == this.detail.type) {
            return this.$t('company.departmentInfo');
          } else {
            return this.$t('company.controlRangeInfo');
          }
        },
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'controlAreaName',
            name: this.$t('company.search.controlName'),
            type: 'input',
            placeholder: this.$t('company.search.controlNamePlaceholder'),
          },
          {
            prop: 'currentStatus',
            name: this.$t('company.search.status'),
            type: 'select',
            placeholder: this.$t('company.search.statusPlaceholder'),
            options: [
              {
                label: '已禁用',
                value: '1',
              },
              {
                label: '已生效',
                value: '0',
              },
            ],
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 235 + 'px';
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        receiptClaimModeList() {
          return this.$baseRequest.getDictListByType('receiveClaimPattern');
        },
      }),
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      getData() {
        this.detail = {};
        this.historyData = [];
        this.edit = false;
        this.load = false;
        this.tableData = [];
        this.unitData = [];
        const query = this.$refs.siruiSearch.query;
        query.tenantCode = this.userInfo.userInfo.tenantCode;
        query.adminFlag = this.userInfo.userInfo.adminFlag;
        this.$axios.post(API.GET_CONTROL_LIST_API, query).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //搜索
      searchBtnClick() {
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.getData();
      },
      chooseClick(type) {
        if (type == 'add') {
          this.addControl();
        } else if (type == 'edit') {
          this.editControl();
        } else if (type == 'forbid') {
          this.fotbidControl();
        } else if (type == 'lift') {
          this.liftControl();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增控制范围
      addControl() {
        if (this.detail.type == 'department') {
          //新增部门
          this.detail.superiorUnitCode = this.detail.createDepartmentCode;
          this.detail.superiorUnit = this.detail.createDepartmentName;
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else if (this.detail.type == 'controlArea') {
          //新增部门
          this.detail.superiorUnitCode = null;
          this.detail.superiorUnit = null;
          this.tableData = [
            {
              controlAreaCode: this.detail.controlAreaCode,
              controlAreaName: this.detail.controlAreaName,
            },
          ];
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else {
          this.$refs.addControl.openDialog(true);
        }
      },
      //编辑控制范围
      editControl() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.editNoTips'),
            type: 'error',
          });
          return;
        }
        this.edit = true;
        this.activeName = 'first';
        if (this.detail.type == 'controlArea') {
          this.$nextTick(() => {
            this.$refs.editControlRange.initDepartment();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.editDepartment.initData();
          });
        }
      },
      //禁用控制范围
      fotbidControl() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '1') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidTips'),
            type: 'error',
          });
          return;
        }
        if (
          this.detail.belongCompanyCode != null &&
          this.detail.belongCompanyName != null &&
          this.detail.belongTenantCode != null
        ) {
          this.$message({
            showClose: true,
            message: this.$t('company.notForbidChild'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.forbid'), this.$t('confirm.forbidContent'))
          .then(() => {
            const params = {
              currentStatus: '1',
              version: this.detail.version,
            };
            this.loading.startLoading();
            let API_STATUS = '';
            if (this.detail.type == 'controlArea') {
              params.controlAreaCode = this.detail.controlAreaCode;
              API_STATUS = API.UPDATE_CONTROL_STATUS_API;
            } else {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            }
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //启用控制范围
      liftControl() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '0') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.lift'), this.$t('confirm.liftContent'))
          .then(() => {
            const params = {
              currentStatus: '0',
              version: this.detail.version,
            };
            let API_STATUS = '';
            if (this.detail.type == 'controlArea') {
              params.controlAreaCode = this.detail.controlAreaCode;
              API_STATUS = API.UPDATE_CONTROL_STATUS_API;
            } else {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            }
            this.loading.startLoading();
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //选择控制范围或部门
      handleNodeClick(data) {
        let API_DETAIL = '';
        if (data.type == 'department') {
          API_DETAIL = API.GET_DEPARTMENT_DETAIL_API;
        } else {
          API_DETAIL = API.GET_CONTROL_AREA_API;
        }
        this.edit = false;
        //管理员可见详情
        if (this.userInfo.userInfo.adminFlag == 1) {
          this.$axios.get(API_DETAIL + '/' + data.id).then((res) => {
            if (0 == res.data.code) {
              if (data.type == 'department') {
                //历史记录
                this.getHistoryData(
                  'department',
                  res.data.data.departmentDetail.createDepartmentCode
                );
                //部门详情
                this.detail = res.data.data.departmentDetail;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.departmentDetail.currentStatus == '0' ? '已生效' : '已禁用';
                //上级单位
                this.unitData = [res.data.data.company || res.data.data.department];
                this.unitData[0].superiorUnitCode = res.data.data.company
                  ? res.data.data.company.createCompanyCode
                  : res.data.data.department.createDepartmentCode;
                //所属控制范围
                this.tableData = res.data.data.controlAreaList;
              } else {
                //历史记录
                this.getHistoryData('controlArea', res.data.data.controlArea.controlAreaCode);
                //控制范围详情
                this.detail = res.data.data.controlArea;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.controlArea.currentStatus == '0' ? '已生效' : '已禁用';
                //关联部门
                this.tableData = res.data.data.departmentList;
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.detail.type = data.type;
          if (data.type == 'department') {
            //历史记录
            this.getHistoryData('department', data.id);
          } else {
            //历史记录
            this.getHistoryData('controlArea', data.id);
          }
        }
      },
      getHistoryData(type, code) {
        this.$refs.historyData.getData(type, code);
      },
      setLoading(obj) {
        this.load = obj.loading;
        if (obj.edit) {
          this.edit = obj.edit;
        }
      },
      //修改保存
      updateSure() {
        if (this.detail.type == 'controlArea') {
          this.$refs.editControlRange.addSure(this.load);
        } else {
          this.$refs.editDepartment.addSure(this.load);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-top: 10px;
  }
  .i-icon {
    float: right;
    i {
      cursor: pointer;
      margin: 0 2px;
    }
  }
  .footer {
    background: #fff;
    height: 60px;
    line-height: 60px;
    margin-top: 10px;
    text-align: center;
  }
</style>
